import findNsfDialogTemplate from './findNSFDialog.template.html';

/*******************************************************************************
 * Directive */
/**
 * @ngdoc   directive
 * @module  csm.books.nsf
 * @name    csm.books.nsf.directive:findNsfDialog
 * @description
 * Allows a user to search for an existing NSF.
 *******************************************************************************/
/* @ngInject */ export function findNsfDialogDirective(ClickDialogDirective) {
  return new ClickDialogDirective({
    controller: Controller,
    template: findNsfDialogTemplate,
    size: 'md',
    scope: { accounts: '<', load: '&' }
  });
}

/*******************************************************************************
 * Controller */
/**
 * @ngdoc   controller
 * @module  csm.books.nsf
 * @name    csm.books.nsf.controller:Controller
 * @description
 * Controls the work flow for the Find NSF Dialog.
 *******************************************************************************/
/* @ngInject */ function Controller(
  $injector,
  $scope,
  $uibModalInstance,
  uiGridConstants,
  SERVER
) {
  /** Self reference. */ var $ctrl = this;
  $ctrl.validators = {};

  /*-----------------------------*/
  /* Set up injection functions. */
  /*-----------------------------*/
  $ctrl.clear = $injector.invoke(clear, null, { $ctrl: $ctrl });
  $ctrl.search = $injector.invoke(search, null, { $ctrl: $ctrl });
  $ctrl.view = $injector.invoke(view, null, { $ctrl: $ctrl, $scope: $scope });
  $ctrl.showAcctNumber = SERVER.BooksWebConstants.showAcctNumber;

  /*---------------------------------*/
  /* Template to add double click    */
  /* functionality to each grid row. */
  /*---------------------------------*/
  var dblClickTemplate =
    '\
  <div ui-grid-cell\
        ng-dblclick="grid.appScope.$ctrl.view(row.entity)"\
          ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name"\
              class="ui-grid-cell">\
  </div>';

  $ctrl.grid = {
    enableColumnMenus: false,
    enableFiltering: false,
    enableRowSelection: true,
    enableFullRowSelection: true,
    enableRowHeaderSelection: false,
    multiSelect: false,
    enableSelectAll: false,
    saveFilter: false,
    saveSort: false,
    rowTemplate: dblClickTemplate,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    onRegisterApi: function (api) {
      $ctrl.grid.api = api;
    },
    data: [],
    columnDefs: [
      { field: 'date', cellFilter: 'date:"MM/dd/yyyy"', width: 90 },
      { field: 'bank' },
      { field: 'checkNumber', displayName: 'Check #', width: 90 },
      {
        field: 'checkAmount',
        displayName: 'Amount',
        cellFilter: 'currency',
        cellClass: 'text-right',
        width: 90
      }
    ]
  };

  $ctrl.clear();
}

/*******************************************************************************
 * clear */
/**
 * Clears the input fields.
 *******************************************************************************/
/* @ngInject */ function clear($ctrl) {
  return function () {
    $ctrl.filters = {
      bankAcctID: NaN,
      checkNumber: null,
      checkAmount: NaN,
      nsfDate: null
    };
  };
}

/*******************************************************************************
 * search */
/**
 * Searches for any NSF records based on the filters entered.
 *******************************************************************************/
/* @ngInject */ function search($ctrl, BusyScreen, NSFChecksService) {
  return function () {
    /*----------------------------------------------------------*/
    /* Ensure that any filters that are required have been set. */
    /*----------------------------------------------------------*/
    $ctrl.validators.reset();
    if (!$ctrl.validators.validate()) return;

    /*----------------------------------------------------------------------*/
    /* Create a copy of the search filters so that we can set the amount    */
    /* value without making a change to the ui when the user clicks Search. */
    /*----------------------------------------------------------------------*/
    var filters = angular.extend({}, $ctrl.filters);
    filters.checkAmount = filters.checkAmount || 0;

    BusyScreen.promise(
      NSFChecksService.findNSFChecks(filters).then(function (nsfs) {
        $ctrl.grid.data = nsfs;
      })
    );
  };
}

/*******************************************************************************
 * view */
/**
 * View the selected NSF in review mode.
 *
 * @param  row  Selected row
 *******************************************************************************/
/* @ngInject */ function view($ctrl, $scope, Alert) {
  return function (row) {
    var nsfs = row ? [row] : $ctrl.grid.api.selection.getSelectedRows();

    /*------------------------------------*/
    /* Must have a single check selected. */
    /*------------------------------------*/
    if (!nsfs.length) {
      Alert.error('Select a check to mark as NSF first', 'No Selection');
      return;
    }

    $ctrl.load({ $nsf: nsfs[0] });
    $scope.$dismiss();
  };
}
